import { gql } from '@apollo/client';

export const UPDATE_PARTNER_EXTRA_INFO = gql`
  mutation updatePartnerExtraInfo($input: UpdatePartnerExtraInfoInput) {
    updatePartnerExtraInfo(input: $input) {
      correlationId
    }
  }
`;
